import { useQuery } from '@apollo/client';
import { useContext, useMemo } from 'react';
import { Calendar } from 'sr-types/lib/search/v1/graphql';
import { UserContext } from '../../../auth/UserContext';
import { FETCH_POLICY_CONFIG } from '../../../constants/constants';
import { ENTITY_CONSTANTS } from '../../../constants/entityConstants';
import { searchClient, slimSearchQuery } from '../../../list/slimQuery';
import { CALENDAR_DATA_PAGE_SIZE } from '../constants';

export const useGetCalendars = (allowedCalendars?: Array<Calendar>) => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const maybeCalendarFilter = useMemo(() => {
        if (!allowedCalendars || allowedCalendars.length === 0) {
            return undefined;
        }

        const allowedCalendarIds = allowedCalendars
            .map((calendar) => calendar.reference?.id ?? calendar.id)
            .filter(Boolean);

        if (allowedCalendarIds.length === 0) {
            return undefined;
        }

        return {
            expressions: [
                {
                    field: 'identity',
                    value: {
                        values: allowedCalendarIds
                    }
                }
            ]
        };
    }, [allowedCalendars]);

    const { data, loading, error } = useQuery(slimSearchQuery(ENTITY_CONSTANTS.calendar), {
        client: searchClient,
        variables: {
            entity: ENTITY_CONSTANTS.calendar,
            page: { from: 0, size: CALENDAR_DATA_PAGE_SIZE },
            filter: maybeCalendarFilter
        },
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
    });

    return {
        calendarsData: (data?.search?.hits?.items ?? []) as Calendar[],
        isLoadingCalendarsData: loading,
        errorLoadingCalendarsData: error
    };
};
